import * as Konva from 'konva';

export class KonvaUtil {
    static drawFormation({ stage, homePlayers = [], fieldId = null, width = null, height = null, awayPlayers = [], ball = null }, noStateUpdate = false) {
        if (!noStateUpdate) {
            if (stage) {
                stage.removeChildren();
                stage.width(width);
                stage.height(height);
            } else {
                stage = new Konva.Stage({
                    container: fieldId,
                    width: width,
                    height: height
                });
            }
        }

        homePlayers.forEach((p, idx) => {
            const cl = new Konva.Layer({
                x: p.x * stage.getWidth() / 448 - 15,
                y: p.y * stage.getHeight() / 448 - 15,
            });
            const circle = new Konva.Circle({
                radius: 15,
                fill: '#3d434b',
                stroke: 'white',
                strokeWidth: 2,
                x: 15,
                y: 15
            });
            const text = new Konva.Text({
                x: 0,
                y: 0,
                text: p.number,
                fill: 'white',
                fontSize: 12
            });
            text.x(15 - text.getWidth() / 2);
            text.y(15 - text.getHeight() / 2);
            if (p.arrows) {
                p.arrows.forEach(arrowType => {
                    const arrow = new Konva.Arrow({
                        x: arrowType === 1 || arrowType === 2 ? 15 : arrowType == 3 ? 30 : arrowType == 4 ? 0
                            : arrowType === 5 || arrowType === 6 ? 22.5 : 7.5,
                        y: arrowType === 3 || arrowType === 4 ? 15 : arrowType == 1 ? 0 : arrowType === 2 ? 30
                            : arrowType === 5 || arrowType === 8 ? 7.5 : 22.5,
                        points: arrowType === 1 ? [0, 0, 0, -15] : arrowType === 2 ? [0, 0, 0, 15] : arrowType == 3 ? [0, 0, 15, 0]
                            : arrowType === 4 ? [0, 0, -15, 0] : arrowType === 5 ? [0, 0, 15, -15]
                                : arrowType === 6 ? [0, 0, 15, 15] : arrowType === 7 ? [0, 0, -15, 15] : [0, 0, -15, -15],
                        pointerLength: 5,
                        pointerWidth: 5,
                        fill: '#3d434b',
                        stroke: '#3d434b',
                        strokeWidth: 4,
                    });
                    cl.add(arrow);
                });
            }
            cl.add(circle);
            cl.add(text);
            stage.add(cl);
        });
        awayPlayers.forEach((p, idx) => {
            const cl = new Konva.Layer({
                x: p.x * stage.getWidth() / 448 - 15,
                y: p.y * stage.getHeight() / 448 - 15,
            });
            const circle = new Konva.Circle({
                radius: 15,
                fill: '#5e91d0',
                stroke: 'white',
                strokeWidth: 2,
                x: 15,
                y: 15
            });
            const text = new Konva.Text({
                x: 0,
                y: 0,
                text: p.number,
                fill: 'white',
                fontSize: 12
            });
            text.x(15 - text.getWidth() / 2);
            text.y(15 - text.getHeight() / 2);
            if (p.arrows) {
                p.arrows.forEach(arrowType => {
                    const arrow = new Konva.Arrow({
                        x: arrowType === 1 || arrowType === 2 ? 15 : arrowType == 3 ? 30 : arrowType == 4 ? 0
                            : arrowType === 5 || arrowType === 6 ? 22.5 : 7.5,
                        y: arrowType === 3 || arrowType === 4 ? 15 : arrowType == 1 ? 0 : arrowType === 2 ? 30
                            : arrowType === 5 || arrowType === 8 ? 7.5 : 22.5,
                        points: arrowType === 1 ? [0, 0, 0, -15] : arrowType === 2 ? [0, 0, 0, 15] : arrowType == 3 ? [0, 0, 15, 0]
                            : arrowType === 4 ? [0, 0, -15, 0] : arrowType === 5 ? [0, 0, 15, -15]
                                : arrowType === 6 ? [0, 0, 15, 15] : arrowType === 7 ? [0, 0, -15, 15] : [0, 0, -15, -15],
                        pointerLength: 5,
                        pointerWidth: 5,
                        fill: '#3d434b',
                        stroke: '#3d434b',
                        strokeWidth: 4,
                    });
                    cl.add(arrow);
                })
            }
            cl.add(circle);
            cl.add(text);
            stage.add(cl);
        });
        if (ball) {
            const cl = new Konva.Layer({
                draggable: true,
                x: ball.x * width / 448 - 5,
                y: ball.y * height / 448 - 5,
            });
            const circle = new Konva.Circle({
                radius: 5,
                fill: '#F18037',
                stroke: 'white',
                strokeWidth: 0,
                x: 5,
                y: 5
            });
            cl.add(circle);
            stage.add(cl);
        }

        return stage;
    }

    static getFile(stage: Konva.Stage): Promise<File> {
        return new Promise((resolve, reject) => {
            const dataURItoBlob = (dataURI) => {
                // convert base64 to raw binary data held in a string
                // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
                const byteString = atob(dataURI.split(',')[1]);
                
                // separate out the mime component
                const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
                
                // write the bytes of the string to an ArrayBuffer
                const ab = new ArrayBuffer(byteString.length);
                
                // create a view into the buffer
                const ia = new Uint8Array(ab);
                
                // set the bytes of the buffer to the correct values
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                
                // write the ArrayBuffer to a blob, and you're done
                const blob = new Blob([ab], {type: mimeString});
                return blob;
            }
    
            try {
                resolve(
                    new File([dataURItoBlob(stage.toDataURL({ quality: 12, mimeType: 'image/png', }))], 'piece.png')
                );
            } catch (e) {
                reject(e);
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/models/utils/konva.util.ts